import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import {
  BoxButtons,
  Box,
  BoxFields,
  CancelButton,
  PrimaryButton,
  StyledLabel,
  Title,
  WrapperTotal,
} from "./styles";

import { IConfiguration } from "../../../../../@types/configuration.type";

interface ModalFormConveniaProps {
  configurations: IConfiguration[];
  open: boolean;
  handleClose: () => void;
  handleSave: (token: string) => void;
}


export const ModalFormConvenia = ({
  configurations,
  open,
  handleClose,
  handleSave
}: ModalFormConveniaProps) => {

  const [token, setToken] = useState<string>("");

  useEffect(() => {
    const conveniaConfigurationToken = configurations.find(x => x.key === "CONFIGURATION_CONVENIA_TOKEN")
    setToken(conveniaConfigurationToken?.value ?? "");
  }, [open]);



  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <WrapperTotal>
          <button title="Fechar" onClick={() => handleClose()}>
            X
          </button>
          <Title>Conectar com o Convênia</Title>
          <Box>
            <StyledLabel>Token da API do Convênia</StyledLabel>
            <BoxFields>
              <TextField
                id="outlined-required"
                label="Token"
                value={token}
                onChange={(e) => {
                  setToken(e.target.value);
              }}
              />

            </BoxFields>
          </Box>

          <BoxButtons>
            <CancelButton onClick={() => handleClose()} type="button">
              Cancelar
            </CancelButton>
            <PrimaryButton onClick={() => handleSave(token)}>Salvar</PrimaryButton>
          </BoxButtons>
        </WrapperTotal>
      </Modal>
    </>
  );
};
